import React, { useState, /*useEffect, useCallback,*/ useContext } from 'react';
import { useParams } from 'react-router-dom';
import ProjectHeader from '@components/project/ProjectHeader';
import Summary from '@components/project/Summary';
import Candidacy from './Candidacy';
import Planning from './Planning';
import Execution from './Execution';
import ExecutionSummarySampling from './ExecutionSummarySampling';
import Advancement from './Advancement';
import ExecutionSummary from './ExecutionSummary';
import Reporting from './Reporting';
import NotFoundPage from 'pages/404';
import PhysicalExecution from './PhysicalExecution';
import ProjectNavHorizontal from '@components/nav/projectNavHorizontal';
import { UserContext } from 'components/contexts/UserProvider';
import { useQuery } from '@tanstack/react-query';
import { Loading } from '@components/atomic/atoms';
import { getProject } from '@lib/api_ts/projectApi';
import { WithPermission } from '@lib/helpers/WithPermission';

const ProjectWizard = () => {
	const { projectId } = useParams();
	const { tab, submenu } = useParams();
	const [summaryWheelsValues, setSummaryWheelsValues] = useState([]);
	const {
		isCoordinator,
		isBeneficiary,
		userAccess: { isProjectManager, isExternalAdmin },
	} = useContext(UserContext);

	const {
		// data: projectFromApi,
		data: project,
		isPending,
		refetch,
	} = useQuery({
		queryKey: ['project', projectId],
		queryFn: () => getProject(projectId),
		refetchOnMount: false,
	});
	const hasSamplingWorkflow = project?.advancedConfig?.some((config) => config.name === 'sampling_activity' && config.enabled);

	if (isPending) return <Loading />;

	if (!project) return <NotFoundPage />;

	return (
		<>
			{/* <ProjectNavHorizontal isCoordinator={isCoordinator} isBeneficiary={isBeneficiary} projectAdvancedConfig={project.advancedConfig} /> */}

			<ProjectHeader
				project={project}
				//  setProject={setProject}
				isProjectManager={isProjectManager}
				fetchDataProject={refetch}
				navigationMenu={
					<ProjectNavHorizontal
						isCoordinator={isCoordinator}
						isBeneficiary={isBeneficiary}
						projectAdvancedConfig={project.advancedConfig}
					/>
				}
			/>

			{(tab === 'dashboard' || !tab) && (
				<Summary project={project} summaryWheelsValues={summaryWheelsValues} setSummaryWheelsValues={setSummaryWheelsValues} />
			)}
			<WithPermission permission="view-candidatura-tab">
				{tab === 'candidacy' && (
					<Candidacy
						project={project}
						summaryWheelsValues={summaryWheelsValues}
						fetchDataProject={refetch}
						isCoordinator={isCoordinator}
						isBeneficiary={isBeneficiary}
					/>
				)}
			</WithPermission>
			<WithPermission permission="view-pianificazione-tab">
				{tab === 'planning' && <Planning project={project} isCoordinator={isCoordinator} isExternalAdmin={isExternalAdmin} />}
			</WithPermission>

			<WithPermission permission="view-avanzamento-tab">
				<WithPermission permission="view-avanzamento-economico-tab">
					{tab === 'execution' && (submenu === 'economic' || !submenu) && (
						<Execution project={project} isCoordinator={isCoordinator} isBeneficiary={isBeneficiary} />
					)}
				</WithPermission>

				<WithPermission permission="view-avanzamento-fisico-tab">
					{tab === 'execution' && submenu === 'physical' && <PhysicalExecution project={project} />}
				</WithPermission>
			</WithPermission>

			{tab === 'summary' &&
				(hasSamplingWorkflow ? (
					<ExecutionSummarySampling project={project} />
				) : (
					<ExecutionSummary project={project} isCoordinator={isCoordinator} />
				))}

			<WithPermission permission="view-monitoraggio-tab">
				{tab === 'advancement' && <Advancement project={project} isCoordinator={isCoordinator} isBeneficiary={isBeneficiary} />}
			</WithPermission>

			<WithPermission permission={['view-rendicontazione-dnsh-tab', 'view-reports-history', 'view-draft-statements']} mode="any">
				{tab === 'reporting' && <Reporting project={project} isCoordinator={isCoordinator} />}
			</WithPermission>
		</>
	);
};
export default ProjectWizard;
